<template>
  <div>
    <h2>安全设置</h2>
    <a-divider></a-divider>
    <a-form layout="vertical" :form="form">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="旧密码">
        <a-input
          type="password"
          placeholder="请输入旧密码"
          v-decorator="['oldpassword', validatorRules.oldpassword]"
        />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新密码">
        <a-input
          type="password"
          placeholder="请输入新密码"
          v-decorator="['password', validatorRules.password]"
        />
      </a-form-item>

      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="确认新密码"
      >
        <a-input
          type="password"
          @blur="handleConfirmBlur"
          placeholder="请确认新密码"
          v-decorator="['confirmpassword', validatorRules.confirmpassword]"
        />
      </a-form-item>


        <!-- <a-button style="display:block;margin: 50px auto;" type="primary" size="large" @click="handleOk">修改密码</a-button> -->
        <a-button type="primary" @click="handleOk">修改密码</a-button>

    </a-form>
  </div>
</template>

<script>
import { putAction } from "@/api/manage";
export default {
  data() {
    return {
      validatorRules: {
        oldpassword: {
          rules: [
            {
              required: true,
              message: "请输入旧密码!",
            },
          ],
        },
        password: {
          rules: [
            {
              required: true,
              message: "请输入新密码!",
            },
            {
              validator: this.validateToNextPassword,
            },
          ],
        },
        confirmpassword: {
          rules: [
            {
              required: true,
              message: "请确认新密码!",
            },
            {
              validator: this.compareToFirstPassword,
            },
          ],
        },
      },
      confirmDirty: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      form: this.$form.createForm(this),
      url: "sys/user/updatePassword",
      username: "",
    };
  },
  created(){
    this.username = this.$store.getters.username;
  },
  methods: {
    handleCancel() {
      this.close();
    },
    close() {
      this.$emit("close");
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = Object.assign({ username: this.username }, values);
          console.log("修改密码提交数据", params);
          putAction(this.url, params)
            .then((res) => {
              if (res.success) {
                that.form.resetFields();
                that.$message.success(res.message);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {});
        }
      });
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次输入的密码不一样！");
      } else {
        callback();
      }
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
  },
};
</script>

<style>
</style>